import { BankQueryKeys } from '@/modules/bank/keys'
import { useQuery } from '@tanstack/react-query'
import { getPaymentGatewayProviders } from '../../services'

export default function useQueryPaymentGatewayProvider() {
	return useQuery({
		queryKey: [BankQueryKeys.PaymentGateProviders],
		queryFn: () => getPaymentGatewayProviders(),
	})
}
